import { DataGridColumn } from '@/components/DataGrid/DataGridColumn.class';
import { Trip } from '@/typing/api/tripNew.class';
import { isUndefined } from '../isUndefined';
import isSameDateAsPreviousTimeValidator from './isSameDateAsPreviousTimeValidator';

const timeValidator = (val: string, item: Trip, column: DataGridColumn, columns: DataGridColumn[]) => {
    if (isUndefined(val)) {
        return { hasError: false };
    }

    const stringVal = val.toString();

    const regex = new RegExp(`(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]`);
    const regexExec = regex.exec(stringVal);

    const result =  {
        hasError:
            regexExec === null ||
            !(regexExec.length > 0 && regexExec[0] === stringVal),
        message: 'Gegeven tijd is niet in het juiste formaat. (uu:mm)',
    };

    if (!result.hasError) {
        return isSameDateAsPreviousTimeValidator(val, item, column, columns);
    }

    return result;
};

export default timeValidator;
